import { Provider } from '@angular/core';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocompleteDefaultOptions } from '@angular/material/autocomplete';
import { MAT_CARD_CONFIG, MatCardConfig } from '@angular/material/card';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';
import { MAT_CHIPS_DEFAULT_OPTIONS, MatChipsDefaultOptions } from '@angular/material/chips';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MAT_LIST_CONFIG, MatListConfig } from '@angular/material/list';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioDefaultOptions } from '@angular/material/radio';
import { MAT_SELECT_CONFIG, MatSelectConfig } from '@angular/material/select';
import { MAT_TABS_CONFIG, MatTabsConfig } from '@angular/material/tabs';

export const NOVA_MATERIAL_FORM_FIELD_DEFAULTS: MatFormFieldDefaultOptions = {
    appearance: 'outline',
    subscriptSizing: 'fixed',
    floatLabel: 'always'
};

export const NOVA_MATERIAL_CHECKBOX_DEFAULTS: MatCheckboxDefaultOptions = {
    color: 'primary'
};

export const NOVA_MATERIAL_RADIO_DEFAULTS: MatRadioDefaultOptions = {
    color: 'primary'
};

export const NOVA_MATERIAL_CHIPS_DEFAULTS: MatChipsDefaultOptions = {
    hideSingleSelectionIndicator: true,
    separatorKeyCodes: []
};

export const NOVA_MATERIAL_LIST_DEFAULTS: MatListConfig = {
    hideSingleSelectionIndicator: true
};

export const NOVA_MATERIAL_SELECT_DEFAULTS: MatSelectConfig = {
    hideSingleSelectionIndicator: true
};

export const NOV_MATERIAL_TABS_DEFAULTS: MatTabsConfig = {
    stretchTabs: false
};

export const NOVA_MATERIAL_CARD_DEFAULTS: MatCardConfig = {
    appearance: 'raised'
};

export const NOVA_MATERIAL_AUTOCOMPLETE_DEFAULTS: MatAutocompleteDefaultOptions = {
    hideSingleSelectionIndicator: true
};

export const NOVA_MATERIAL_PROVIDERS: Provider[] = [
    {
        provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
        useValue: NOVA_MATERIAL_AUTOCOMPLETE_DEFAULTS
    },
    {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: NOVA_MATERIAL_FORM_FIELD_DEFAULTS
    },
    {
        provide: MAT_CARD_CONFIG,
        useValue: NOVA_MATERIAL_CARD_DEFAULTS
    },
    {
        provide: MAT_CHIPS_DEFAULT_OPTIONS,
        useValue: NOVA_MATERIAL_CHIPS_DEFAULTS
    },
    {
        provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
        useValue: NOVA_MATERIAL_CHECKBOX_DEFAULTS
    },
    {
        provide: MAT_RADIO_DEFAULT_OPTIONS,
        useValue: NOVA_MATERIAL_RADIO_DEFAULTS
    },
    {
        provide: MAT_LIST_CONFIG,
        useValue: NOVA_MATERIAL_LIST_DEFAULTS
    },
    {
        provide: MAT_SELECT_CONFIG,
        useValue: NOVA_MATERIAL_SELECT_DEFAULTS
    },
    {
        provide: MAT_TABS_CONFIG,
        useValue: NOV_MATERIAL_TABS_DEFAULTS
    }
];
